import React, { useState, useEffect } from 'react';

const Timer = ({duration,active}) => {
    const [time, setTime] = useState(duration);

  useEffect(() => {
    if (time > 0) {
      const timer = setTimeout(() => setTime(time - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [time, active]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return <div>{formatTime(time)}</div>;
};

export default Timer;
